import { Laptop, Phone } from 'lucide-react'

import { ButtonGroup, Modal } from 'slab'

import CopyButton from '../../reusable/CopyButton'

const STRIPE_PAYMENTS_COMPANY_NAME = 'Stripe Payments Company'
const ACH_COMPANY_ID_1 = '1800948598'
const ACH_COMPANY_ID_2 = '4270465600'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function AchAuthorizationModal ({ open, onOpenChange }: Props) {
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      width='medium'
      aria-describedby={undefined}
    >
      <Modal.Header>
        <Modal.Title>
          Let your bank know about your upcoming Thatch payments
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p className='body-sm'>
            An ACH company ID is a 10-digit identifier used to identify the business charging your account.
          </p>
          <p className='body-sm mt-4'>
            Some business bank accounts have filters to deny payments from unknown accounts. To ensure Thatch's charges aren't blocked, you may need to let your bank know that we're an allowed recipient.
          </p>
          <div className='mt-10'>
            <h3 className='heading-sm mb-3'>How to get set up</h3>
            <div className='flex gap-3'>
              <div className='flex flex-col shrink-0'>
                <Laptop className='shrink-0' size={16} />
              </div>
              <div className='flex-1'>
                <p className='body-sm'>
                  You can check if your bank lets you do this online by logging in and navigating to a section that'll be titled something like Pay & Transfer or Send Money.
                </p>
                <p className='body-sm mt-3'>
                  In there, you should see an option to Add a new recipient, then enter the ACH company IDs:
                </p>
                <div className='bg-[#FAFAFA] rounded-2xl p-4 mt-4 space-y-2'>
                  <div className='flex items-center gap-2'>
                    <span className='body-sm'>{ACH_COMPANY_ID_1} - {STRIPE_PAYMENTS_COMPANY_NAME}</span>
                    <CopyButton valueToCopy={ACH_COMPANY_ID_1} />
                  </div>
                  <div className='flex items-center gap-2'>
                    <span className='body-sm'>{ACH_COMPANY_ID_2} - {STRIPE_PAYMENTS_COMPANY_NAME}</span>
                    <CopyButton valueToCopy={ACH_COMPANY_ID_2} />
                  </div>
                </div>
              </div>
            </div>
            <div className='flex gap-3 mt-4'>
              <div className='flex flex-col shrink-0'>
                <Phone className='shrink-0' size={16} />
              </div>
              <div className='flex-1'>
                <p className='body-sm'>
                  Unfortunately, if you don't see anywhere to add ACH company IDs online, you'll need to call and provide this information over the phone.
                </p>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup align='right'>
          <Modal.Button
            variant='primary'
            onClick={() => {
              onOpenChange(false)
            }}
          >
            Close
          </Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
